import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9c1.65685 0 3-1.34315 3-3S9.65685 3 8 3 5 4.34315 5 6s1.34315 3 3 3zm9 5c1.6569 0 3-1.3431 3-3 0-1.65685-1.3431-3-3-3s-3 1.34315-3 3c0 1.6569 1.3431 3 3 3zm-2.26 1.44c-.9397.277-1.624 1.0872-1.74 2.06V21h8v-3.5c-.116-.9728-.8003-1.783-1.74-2.06-1.4141.7467-3.1059.7467-4.52 0zM13 14.13c-1.1992.7073-1.9536 1.9785-2 3.37V21H3v-8h.07c.37841-1.2513 1.36444-2.226 2.62-2.59.71116.3801 1.50369.5825 2.31.59.80631-.0075 1.59884-.2099 2.31-.59 1.2556.364 2.2416 1.3387 2.62 2.59H13v1.13z",
    fill: "currentColor"
  }));
});